import { useEffect } from "react";
import { useAuth } from "providers/auth";

export const SESSION_IDENTITY = "sessionIdentity";

export const useSessionTabSync = () => {
  const { user, isReady } = useAuth();
  const identity = user ? `${user.role}:${user.id}` : "anonymous";

  useEffect(() => {
    if (!isReady) {
      return;
    }

    localStorage.setItem(SESSION_IDENTITY, identity);

    const reloadIfSessionChanged = () => {
      const storedIdentity = localStorage.getItem(SESSION_IDENTITY);

      if (storedIdentity !== null && storedIdentity !== identity) {
        window.location.reload();
      }
    };

    const handleStorage = (event: StorageEvent) => {
      if (event.key === SESSION_IDENTITY) {
        reloadIfSessionChanged();
      }
    };

    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        reloadIfSessionChanged();
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        reloadIfSessionChanged();
      }
    };

    window.addEventListener("storage", handleStorage);
    window.addEventListener("pageshow", handlePageShow);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("pageshow", handlePageShow);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isReady, identity]);
};
